// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0

export const ensureNoTrailingSlash = (url: string): string => {
  return url.endsWith('/') ? url.slice(0, -1) : url;
};

/**
 * Encodes an allow list name for use in URLs.
 */
export const encodeAllowListName = (name: string): string => {
  return encodeURIComponent(name);
};

/**
 * Decodes an allow list name from a URL parameter.
 */
export const decodeAllowListName = (encoded: string): string => {
  return decodeURIComponent(encoded);
};

export const encodeDenyListName = (name: string): string => {
  return encodeURIComponent(name);
};

export const decodeDenyListName = (encoded: string): string => {
  return decodeURIComponent(encoded);
};
